import customAxios from "../../customAxios";
import {GET_ALL_PROVINCE} from "../../routes";

const getAllProvince = async () => {
  try {
    return (await customAxios.get(GET_ALL_PROVINCE)).data;
  } catch (error: any) {
    console.log({GET_ALL_PROVINCE: error});
  }
};

export default getAllProvince;
